import { Button } from "@rio-cloud/rio-uikit";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

const MONTH_LINE_HEIGHT = 22;
const MONTH_WIDTH = 180;

export default function MonthNavigationSkeleton() {
  return (
    <div className="position-relative">
      <div className="display-flex align-items-center justify-content-between gap-20 bg-lightest padding-15 rounded width-100pct cursor-default">
        <Button variant={Button.VARIANT_LINK} iconOnly iconName="rioglyph-triangle-left" />
        <span className="text-size-h4">
          <ContentLoader className="skeleton-on-light-bg" height={MONTH_LINE_HEIGHT} width={MONTH_WIDTH} />
        </span>
        <Button variant={Button.VARIANT_LINK} iconOnly iconName="rioglyph-triangle-right" />
      </div>
    </div>
  );
}
